import { Controller, useFormContext } from "react-hook-form";
import { TextArea } from "@tricura/atlas-ui";
import { FormGroup } from "../../../../components/form-group";
import type { UwInformationFormData } from "../schema";

const MAX_LENGTH = 600;

export function SubmissionNotesSection() {
    const { control } = useFormContext<UwInformationFormData>();

    return (
        <FormGroup title="Submission Notes">
            <Controller
                control={control}
                name="note"
                render={({ field, fieldState }) => {
                    const remaining = Math.max(0, MAX_LENGTH - (field.value?.length ?? 0));
                    return (
                        <TextArea
                            label="Notes / Remarks"
                            rows={4}
                            maxLength={MAX_LENGTH}
                            value={field.value}
                            onChange={field.onChange}
                            hint={fieldState.error?.message ?? `${remaining} characters left`}
                            isInvalid={fieldState.invalid}
                            data-autotest="uw-information-submission-notes-input"
                        />
                    );
                }}
            />
        </FormGroup>
    );
}
